import React, { useContext } from "react";
import { IndexData } from '../../../index-context';
import TrBaseComparisonProducts from './tr-base-comparison-products';

const TrRankingCompetitors = ({ checkedConcepts }) => {
  const { data } = useContext(IndexData);
  return (
    <TrBaseComparisonProducts
      checkedConcepts={ checkedConcepts }
      sectionTitle={ data.titles.rank_competitors }
      kindName={ 'ranking_top3_competitors' }
    />
  );
};

export default TrRankingCompetitors;
